module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.be7691c1.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.eot?v=3.6.95
// module id = 815
// module chunks = 0